import { render } from "./calcolatore.vue?vue&type=template&id=64ac9cfa&bindings={}"
import script from "./calcolatore.vue?vue&type=script&lang=js"
export * from "./calcolatore.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./calcolatore.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script